import Pantone from '../../../../../../../types/api/pantone'
import { PrintJobPaints } from '../../../../../../../types/api/print-job-paints'
import { PaintRowDraft } from '../types'
import { getBrandReference } from './get-brand-reference'
import { getRowPantoneName } from './get-row-pantone-name'
import { groupPantoneVersions } from './group-pantone-versions'
import { toCellDrafts } from './to-cell-drafts'

const DEFAULT_MANUFACTURER = 'SupraFlex'

/**
 * Карточки модалки: сохранённый черновик как есть, иначе — эталон (рецепт без версии)
 * SupraFlex, если его нет — другого бренда.
 */
export function toRowDrafts(paints: PrintJobPaints, pantones: Pantone[]): PaintRowDraft[] {
    const defaultManufacturer = paints.manufacturers.find(
        item => item.name === DEFAULT_MANUFACTURER
    )

    return paints.rows.map(row => {
        const { form, draft } = row
        const pantoneName = getRowPantoneName(row)
        const base: PaintRowDraft = {
            form,
            pantoneName,
            versions: groupPantoneVersions(pantones, pantoneName, paints.manufacturers),
            manufacturerDocumentId: defaultManufacturer?.documentId ?? null,
            referencePantoneDocumentId: null,
            colorants: [],
            portions: null,
        }

        if (draft) {
            return {
                ...base,
                manufacturerDocumentId: draft.manufacturerDocumentId,
                referencePantoneDocumentId: draft.referencePantoneDocumentId,
                colorants: toCellDrafts(draft.colorants),
                portions: draft.portions,
            }
        }

        const reference =
            getBrandReference(base, defaultManufacturer?.documentId ?? '') ??
            paints.manufacturers
                .map(item => getBrandReference(base, item.documentId))
                .find(Boolean) ??
            null

        // Без эталона — первый бренд, у которого есть рецепты, иначе выбранный бренд окажется заблокирован
        const brandWithRecipes = paints.manufacturers.find(
            item => base.versions[item.documentId]?.length
        )

        return {
            ...base,
            manufacturerDocumentId:
                reference?.manufacturer?.documentId ??
                brandWithRecipes?.documentId ??
                base.manufacturerDocumentId,
            referencePantoneDocumentId: reference?.documentId ?? null,
            colorants: toCellDrafts(reference?.colorants),
        }
    })
}
